import * as React from "react";

import { ITheme, mergeStyles } from "@fluentui/react/lib/Styling";

import { GalleryListLevelInfo } from "@1js/acui-gallery";
import { AppThemeConsumer } from "@1js/acui-theme";

import { getListGalleryButtonStyles } from "../AppListGallery/AppListGallery.styles";
import { AppDirectionalListGalleryButtonProps } from "./AppDirectionalListGalleryButton.Props";

export const AppDirectionalListGalleryButton: React.StatelessComponent<AppDirectionalListGalleryButtonProps> =
  React.memo((props: AppDirectionalListGalleryButtonProps) => {
    const { infoAtLevel, rtl, id, multiLevel } = props;

    // this is to handle the 'None' case
    if (!Array.isArray(infoAtLevel)) {
      return (
        <div className={mergeStyles(infoAtLevel.styleAtLevel)}>
          {infoAtLevel.textAtLevel}
        </div>
      );
    }

    return (
      <AppThemeConsumer>
        {(theme: ITheme) => {
          const listStyles = getListGalleryButtonStyles(theme, rtl, multiLevel);
          return (
            <div className={mergeStyles(listStyles.root)}>
              {infoAtLevel.map((info: GalleryListLevelInfo, index: number) => {
                return (
                  <div
                    key={id + "-" + index + "-level"}
                    className={mergeStyles(
                      listStyles.levels && listStyles.levels[index],
                      info.styleAtLevel
                    )}
                  >
                    <span>{info.textAtLevel}</span>
                    <span className={mergeStyles(listStyles.line)} />
                  </div>
                );
              })}
            </div>
          );
        }}
      </AppThemeConsumer>
    );
  });
